import { stateReportRequest } from './stateReportTransport';
import { api } from '../index';
import { objectToFormData, serialize } from '@/api/util';
import { requestSalesHistorySummary } from './salesHistorySummaryApi';

const prefix = '/api/report/';

export function apiIndex(param) {
	if (!param) return api.get(prefix + 'index');
	else return api.get(prefix + 'index' + param);
}

// AI Query (natural-language). super_admin only (backend-gated). param: { question, context }
export function apiNlQuery(param) {
	return api.post(prefix + 'nlquery', param);
}

// #3406 : config 는 State 제한 사용자의 SO 상세가 차단 응답을 화면에서 흡수할 때만 넘긴다.
export function apiArAging(param, config) {
	return api.post(prefix + 'arAging', param, config);
}

// #3108 JC: A/R Summary (Current = payment term 미도래)
export function apiArCurrentSummary(date) {
	return api.get(prefix + 'arCurrentSummary', { params: { date } });
}

export function apiArAgingV2(param) {
	return api.post(prefix + 'arAgingV2', param);
}

export function apiReceiptType(param) {
	return stateReportRequest(this, api, 'post', prefix + 'receiptType', param);
}

export function apiArBalanceBySalesGroup(param) {
	return stateReportRequest(this, api, 'post', prefix + 'arBalanceBySalesGroup', param);
}
export function apiPackingStatus(param) {
	return api.post(prefix + 'packingStatus', param);
}

export function apiPackingInfoWithStatusWI(date, from_date, to_date) {
	return api.get(prefix + 'packingInfoWithStatusWI', { params: { date, from_date, to_date } });
}

export function apiStatusOfInvoiceInWeekAndToday() {
	return api.get(prefix + 'statusOfInvoiceInWeekAndToday');
}

export function apiImmediatePayment(param) {
	return stateReportRequest(this, api, 'post', prefix + 'immediatePayment', param);
}

export function apiSalesReturnReceipt(param) {
	return stateReportRequest(this, api, 'post', prefix + 'salesReturnReceipt', param);
}
export function apiSalesOrderList(param) {
	return stateReportRequest(this, api, 'post', prefix + 'salesOrderList', param);
}

export function apiSalesTemplate(param) {
	return stateReportRequest(this, api, 'post', prefix + 'salesTemplate', param);
}

export function apiSalesTemplateByRawData(param) {
	return stateReportRequest(this, api, 'post', prefix + 'salesTemplateByRawData', param);
}

export function apiSalesHistorySummary(param) {
	return requestSalesHistorySummary(param);
}

export function apiLandingRates(param) {
	return stateReportRequest(this, api, 'post', prefix + 'landingRates', param);
}

export function apiVendorAnalyzeItem(param) {
	return api.post(prefix + 'vendorAnalyze/item', param);
}

export function apiVendorAnalyzeItemV2(param) {
	return api.post(prefix + 'vendorAnalyze/itemV2', param);
}

export function apiPurchaseByVendor(vendor_code, from_date, to_date) {
	return api.get(prefix + 'selectPurchaseByVendor', { params: { vendor_code, from_date, to_date } });
}

export function apiPurchaseByVendorForJc(vendor_code, from_date, to_date) {
	return api.get(prefix + 'selectPurchaseByVendorForJc', { params: { vendor_code, from_date, to_date } });
}

export function apiSelectSalesGoodsList(param) {
	return stateReportRequest(this, api, 'post', prefix + 'selectSalesGoodsList', param);
}

export function apiStreamSalesGoodsList(param) {
	return api.post(prefix + 'streamSalesGoodsList', param);
}

export function apiSelectSalesGoodsBySalesGroup(invoice_date_from, invoice_date_to, exclude_sales_group_arr, exclude_color_arr) {
	return stateReportRequest(this, api, 'post', prefix + 'selectSalesGoodsBySalesGroup', objectToFormData({ invoice_date_from, invoice_date_to, exclude_sales_group_arr, exclude_color_arr }));
}

export function apiSelectCustomerStatement(param) {
	return api.post(prefix + 'selectCustomerStatement', param);
}
/*
export function apiCustomerStatementData(param) {
	return api.post(prefix + 'customerStatementData', param);
}

export function apiCustomerStatement(bill_to_code, param) {
	return api.get(prefix + 'customerStatement/' + bill_to_code + objectToUrlParam(param));
}

export function apiCustomerStatementList(param) {
	return api.get(prefix + 'customerStatementList' + objectToUrlParam(param));
}
*/

export function apiSelectItemAgingList(param) {
	return api.post(prefix + 'selectItemAgingList', param);
}

export function apiCustomersWOItems(param) {
	return stateReportRequest(this, api, 'post', prefix + 'customersWOItems', param);
}

export function apiLandingRegion(param) {
	return stateReportRequest(this, api, 'post', prefix + 'landingRegion', param);
}
export function apiLandingRegionGroup(param) {
	return stateReportRequest(this, api, 'post', prefix + 'landingRegionGroup', param);
}

export function apiGpsIndex() {
	return api.get(prefix + 'gpsIndex');
}

export function apiSelectGPSLogList(param) {
	return api.post(prefix + 'selectGPSLogList', param);
}

export function apiSalesTopRecordClass(param) {
	return stateReportRequest(this, api, 'post', prefix + 'salesTopRecord/class', param);
}
export function apiSalesTopRecordCustomer(param) {
	return stateReportRequest(this, api, 'post', prefix + 'salesTopRecord/customer', param);
}

export function apiApprovedBackOrder(param) {
	return stateReportRequest(this, api, 'get', prefix + 'approved/back-order' + param);
}

export function apiInventorySheet(param) {
	return api.get(prefix + 'inventory-sheet' + param);
}

export function apiPackingPerStaff(from_date, to_date, user_id, type, so_keyword, ship_to_code, bill_to_code, box_type, sort_key, sort_direction) {
	return api.get(prefix + 'packing_per_staff', { params: { from_date, to_date, user_id, type, so_keyword, ship_to_code, bill_to_code, box_type, sort_key, sort_direction } });
}

export function apiSalesByState(param) {
	return stateReportRequest(this, api, 'post', prefix + 'sales_by_state', param);
}

export function apiSalesPerYear(from_year, to_year, country, state, sales_group_code, exclude_us) {
	return stateReportRequest(this, api, 'get', prefix + 'sales_per_year', { params: { from_year, to_year, country, state, sales_group_code, exclude_us } });
}

export function apiNoCertainItemsCustomer(param) {
	return stateReportRequest(this, api, 'get', prefix + 'no-certain-items-customer' + param);
}

export function apiScannedSOItems(so_dn) {
	return api.get(prefix + 'scanned_so_items', { params: { so_dn } });
}

export function apiSelectSalesByCustomer(from_date, to_date, customer_codes, sales_groups) {
	return stateReportRequest(this, api, 'post', prefix + 'sales_by_customer', objectToFormData({ from_date, to_date, customer_codes, sales_groups }));
}

export function apiSelectPurchaseOverviewByPurchaseItem(params) {
	return api.get(prefix + 'purchase/overview/purchase_item', { params: serialize(params) });
}

export function apiSelectPurchaseOverviewByPo(params) {
	return api.get(prefix + 'purchase/overview/po', { params: serialize(params) });
}

export function apiSelectPurchaseOverviewByVendor(params) {
	return api.get(prefix + 'purchase/overview/vendor', { params: serialize(params) });
}

export function apiSelectPurchaseOverviewByItem(params) {
	return api.get(prefix + 'purchase/overview/item', { params: serialize(params) });
}

export function apiSelectPurchaseOverviewByVendorItem(params) {
	return api.get(prefix + 'purchase/overview/vendor_item', { params: serialize(params) });
}

export function apiStreamPurchaseOverviewByPurchaseItem(params) {
	return api.get(prefix + 'purchase/overview/streamPurchaseItem', { params: serialize(params) });
}

export function apiSelectSalesOverviewByCustomer(params) {
	return stateReportRequest(this, api, 'get', prefix + 'sales/overview/customer', { params: serialize(params) });
}

export function apiSelectSalesOverviewByItem(params) {
	return stateReportRequest(this, api, 'get', prefix + 'sales/overview/item', { params: serialize(params) });
}

export function apiSelectSalesOverviewByCustomerItem(params) {
	return stateReportRequest(this, api, 'get', prefix + 'sales/overview/customer_item', { params: serialize(params) });
}

export function apiSelectSalesOverviewByInvoice(params) {
	return stateReportRequest(this, api, 'get', prefix + 'sales/overview/invoice', { params: serialize(params) });
}

export function apiSelectSalesOverviewByInvoiceItem(params) {
	return stateReportRequest(this, api, 'get', prefix + 'sales/overview/invoice_item', { params: serialize(params) });
}

export function apiStreamSalesOverviewByInvoiceItem(params) {
	return api.get(prefix + 'sales/overview/streamInvoiceItem', { params: serialize(params) });
}

export function apiStockVSReorder(item_classes, months_of_sales) {
	return api.post(prefix + 'stockVSReorderPoint', objectToFormData({ item_classes, months_of_sales }));
}

export function apiStockVSReorderJc(item_classes) {
	return api.post(prefix + 'stockVSReorderPointJc', objectToFormData({ item_classes }));
}

// #3119 JC: Sales On Order Detail (고객별 미인보이스 open sales order)
// null은 FormData에서 문자열 "null"로 직렬화되므로 빈 값은 ''로 강제 (매퍼 <if>가 스킵하도록)
export function apiSoOnOrderByCustomer(bill_to_code, sales_group_code) {
	return stateReportRequest(this, api, 'post', prefix + 'selectSoOnOrderByCustomer', objectToFormData({ bill_to_code: bill_to_code || '', sales_group_code: sales_group_code || '' }));
}

export function apiSelectARNotificationLog(from_date, to_date, purpose, payment_term_code, recipient_code, only_fail_result) {
	return api.get(prefix + 'selectARNotificationLog', { params: { from_date, to_date, purpose, payment_term_code, recipient_code, only_fail_result } });
}

export function apiPrevPurchaseShipmentGroupByItemMaster(po_no) {
	return api.get(prefix + 'prevPurchaseShipmentGroupByItemMaster', { params: { po_no } });
}

export function apiPurchaseHistoryByGoods(param) {
	return api.post(prefix + 'purchaseHistoryByGoods', objectToFormData(param));
}

export function apiAnnualHistoryByGoods(param) {
	return api.post(prefix + 'annualHistoryByGoods', objectToFormData(param));
}

export function apiDailyProgress(param) {
	return stateReportRequest(this, api, 'post', prefix + 'dailyProgress', param);
}

export function apiItemInquiryByPartner(comparison_target, partner_code, class_arr, group_code, active_yn) {
	return stateReportRequest(this, api, 'post', prefix + 'itemInquiryByPartner', objectToFormData({ comparison_target, partner_code, class_arr, group_code, active_yn }));
}

// status_display 부분
export function apiSelectStatusDisplay() {
	return api.get(prefix + 'selectStatusDisplay');
}

export function apiUpdateStatusDisplay(status_display) {
	return api.post(prefix + 'updateStatusDisplay', status_display);
}

export function apiSelectLoginLogList(param) {
	return api.post(prefix + 'selectLoginLogList', param);
}

export function apiSelectFirstSaleCustomerList(param) {
	return stateReportRequest(this, api, 'post', prefix + 'selectFirstSaleCustomerList', param);
}

export function apiSelectShortDateList(param) {
	return api.post(prefix + 'selectShortDateList', param);
}

export function apiHistoricalSalesByItem(param) {
	return stateReportRequest(this, api, 'post', prefix + 'historicalSalesByItem', param);
}

export function apiAnnualSalesArSummary(param) {
	return stateReportRequest(this, api, 'post', prefix + 'annualSalesArSummary', param);
}

// #3105 JC: Delivery List (Ship/PickUp Date 기준 배송 명단)
export function apiDeliveryList(from_date, to_date, delivery_type_code) {
	return stateReportRequest(this, api, 'get', prefix + 'deliveryList', { params: { from_date, to_date, delivery_type_code } });
}

// #3105 JC: Daily Transaction Summary (일일 거래 요약 - 매출/입금/구매/AP지급)
export function apiDailyTransactionSummary(date) {
	return api.get(prefix + 'dailyTransactionSummary', { params: { date } });
}
